import React from 'react';
import { SyutSelect } from 'components/ui';
import type { DateRangePreset } from 'hooks/useDateRangePreset';
import { PRESET_OPTIONS } from 'hooks/useDateRangePreset';

interface Props {
  preset: DateRangePreset;
  /** Used when preset === 'CUSTOM'. */
  from: string;
  to: string;
  onPresetChange: (p: DateRangePreset) => void;
  onFromChange: (date: string) => void;
  onToChange: (date: string) => void;
}

/**
 * Standard date-range filter used by every dashboard / report. When the user
 * picks `CUSTOM`, the from/to date inputs become editable; otherwise they're
 * read-only and reflect the resolved preset window.
 */
const DateRangePresetSelector: React.FC<Props> = ({
  preset, from, to, onPresetChange, onFromChange, onToChange,
}) => {
  const isCustom = preset === 'CUSTOM';
  return (
    <>
      <div className="filter-field filter-field--narrow">
        <SyutSelect
          label="Range"
          value={preset}
          options={PRESET_OPTIONS.map((o) => ({ value: o.value, label: o.label }))}
          onChange={(v) => onPresetChange(v as DateRangePreset)}
          isClearable={false}
          size="sm"
        />
      </div>
      <div className="filter-field filter-field--narrow">
        <label
          className="form-label"
          style={{ fontSize: '0.75rem', marginBottom: '0.25rem', display: 'block' }}
        >From</label>
        <input
          type="date"
          className="form-input"
          value={from}
          disabled={!isCustom}
          onChange={(e) => onFromChange(e.target.value)}
          style={{ fontSize: '0.85rem', padding: '0.375rem 0.625rem', width: '100%' }}
        />
      </div>
      <div className="filter-field filter-field--narrow">
        <label
          className="form-label"
          style={{ fontSize: '0.75rem', marginBottom: '0.25rem', display: 'block' }}
        >To</label>
        <input
          type="date"
          className="form-input"
          value={to}
          disabled={!isCustom}
          onChange={(e) => onToChange(e.target.value)}
          style={{ fontSize: '0.85rem', padding: '0.375rem 0.625rem', width: '100%' }}
        />
      </div>
    </>
  );
};

export default DateRangePresetSelector;
